import { render, staticRenderFns } from "./EmployeeRecognitionList.vue?vue&type=template&id=6bf12690"
import script from "./EmployeeRecognitionList.vue?vue&type=script&lang=js"
export * from "./EmployeeRecognitionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports